import { createContext } from "react";
import { EnvironmentVariables } from "./env";

const EnvContext = createContext<EnvironmentVariables | null>(null);

export default EnvContext;
